var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.511 13.177 7.44 7.605a1.54 1.54 0 0 1 0 2.144 1.46 1.46 0 0 1-2.097 0l-7.74-7.912",
    stroke: "#13123A",
    strokeWidth: 0.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#13123A",
    strokeWidth: 0.91,
    cx: 7.861,
    cy: 8.035,
    rx: 7.406,
    ry: 7.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#E5A033",
    strokeWidth: 0.606,
    cx: 7.932,
    cy: 8.064,
    rx: 5.629,
    ry: 5.761
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.74ce1a7e5d324175901679f3fa5b0620.svg";
export { ForwardRef as ReactComponent };